import axios from "axios";
import { configs } from "../app/app-configs";
import { Member, MemberLoginStatusChangeRequest, MemberRequest, MemberSummary } from "./model/member.model";
import { s3Axios } from "./axios/axios.call.service";

export const getMembers = async (): Promise<Member[]> => {
    return await axios.get(`${configs.BASE_URL}/member`)
    .then(res => {
        return res.data as Member[];
    });
}

export const getPresignedUrl = async (memberId: number, extension: string): Promise<string> => {
    return await axios.get(`${configs.BASE_URL}/member/profile-picture/presigned-url/${memberId}`, {
        params: {extension}
    })
    .then(res => {
        return res.data as string;
    });
}

// export const getMemberPage = async (
//     search: MemberSearchCriteria
// ): Promise<PaginatedResponse<Member>> => {
//     return await axios
//         .get(
//             `${configs.BASE_URL}/member?page=${search.pagination.page}&size=${search.pagination.size}&name=${search.name}`
//         )
//         .then((res) => {
//             return res.data as PaginatedResponse<Member>;
//         });
// };

export const getMember = async (id: number): Promise<Member> => {
    return await axios.get(`${configs.BASE_URL}/member/${id}`)
    .then(res => {
        return res.data as Member;
    });
}

export const getMemberSummary = async (): Promise<MemberSummary> => {
    return await axios.get(`${configs.BASE_URL}/member/summary`)
    .then(res => {
        return res.data as MemberSummary;
    });
}

export const createMember = async (request: MemberRequest): Promise<Member> => {
    return await axios.post(`${configs.BASE_URL}/member`, request)
    .then(res => {
        return res.data as Member;
    });
}

export const updateMember = async (request: MemberRequest): Promise<Member> => {
    return await axios.put(`${configs.BASE_URL}/member/${request.id}`, request)
    .then(res => {
        return res.data as Member;
    });
}

export const updateMemberLoginStatus = async (request: MemberLoginStatusChangeRequest): Promise<Member> => {
    return await axios.put(`${configs.BASE_URL}/member/login/${request.memberId}`, request)
    .then(res => {
        return res.data as Member;
    });
}

export const deleteMember = async (id: number): Promise<number> => {
    return await axios.delete(`${configs.BASE_URL}/member/${id}`)
    .then(res => {
        return res.data;
    });
}

export async function uploadProfileImageToS3(
    preSignedUrl: string,
    file: File | Blob
): Promise<void> {
    await s3Axios.put(preSignedUrl, file, {
        headers: {
            'Content-Type': 'image/jpeg',
        },
    }).catch(error => {
        console.log(error);
    });
}

export async function deleteProfileImage(
    memberId: number
): Promise<void> {
    await axios.delete(`${configs.BASE_URL}/member/profile-image/${memberId}`)
    .catch(err => {
        console.error(err);
    })
}

export async function updateMemberImageReference(
    memberId: number,
    imageKey: string | null
): Promise<Member> {
    return await axios.patch(`${configs.BASE_URL}/member/profile-image/${memberId}`, {
        profileImage: imageKey,
    });
}